module.exports = __webpack_public_path__ + "img/targetOrange.e6bcfc52.jpg";